import * as React from "react";
import { connect } from "react-redux";
import {  Row, Col, Alert } from 'react-bootstrap'
import { FirebaseClient } from "../../firebase/FirebaseClient";
import { logIn } from '../../redux/actions/loginActions';
import queryString from 'query-string';
// import passwordStrength from 'check-password-strength'


import './login.scss'
// import { Link } from "react-router-dom";
// import { sendPasswordResetSuccess } from "../../requests/blueprintRequests";

enum WorkflowState {
  INIT,
  VERIFY_CODE_STARTED,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_FAIL,
  // RESET_PASSWORD_STARTED,
  // RESET_PASSWORD_SUCCSS,
  // RESET_PASSWORD_FAIL,
}

interface IProps {
  logInConnect: (username: string, password: string) => void;
  // location: { query: any, pathname: string }
  location: any;
}

interface OwnProps { }

interface IState {
  // email: string;
  // password: string;
  // confirmpassword: string;
  // [key: string]: any;
  submitError?: any;
  verifyCode: string;
  workflowState: WorkflowState;
}

class VerifyEmail extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      // email: '',
      // password: '',
      // confirmpassword: '',
      verifyCode: '',
      workflowState: WorkflowState.INIT,
    };
  }

  handleChange(fieldName: string, event: any) {
    const value = event.target.value;
    const state: any = {};
    state[fieldName] = value;
    if (fieldName === 'password' || 'confirmpassword') {
      state.workflowState = WorkflowState.VERIFY_CODE_SUCCESS;
    }
    this.setState(state);
  }

  componentDidMount() {
    const parsedQueryString = queryString.parse(this.props.location.search);
    // let email = '';
    let verifyCode = ''

    // if (typeof parsedQueryString.email === 'string') {
    //   email = parsedQueryString.email;
    // }
    if (typeof parsedQueryString.verifyCode === 'string') {
      verifyCode = parsedQueryString.verifyCode;
    }

    if (verifyCode !== '') {
      this.setState({  verifyCode, workflowState: WorkflowState.VERIFY_CODE_STARTED })
      FirebaseClient.getInstance().getFirebaseAuth().applyActionCode(verifyCode)
        .then(() => {
          this.setState({ workflowState: WorkflowState.VERIFY_CODE_SUCCESS })
        }).catch(error => {
          this.setState({ submitError: error, workflowState: WorkflowState.VERIFY_CODE_FAIL })
        })
    } else {
      // to display page when no link,
      this.setState({  workflowState: WorkflowState.VERIFY_CODE_FAIL, submitError: {message: 'Verify code not available'} })
    }
  }

  // autocontrol = (fieldName: string) => ({
  //   name: fieldName,
  //   value: this.state[fieldName] || '',
  //   onChange: this.handleChange.bind(this, fieldName),
  //   className: 'form-control',
  // });

  render() {

    const VerifyCodeFailedUI =
      <div>
        <Row>
          <Col> Verify Email </Col>

          <Col sm={12}>
            <Alert variant='warning'>
              {this.state.submitError?.message}
            </Alert>
          </Col>
        </Row>

      </div>;

    const PasswordChangeSuccessdUI =
      <div>
        <Row>
          <Col> Verify Email </Col>

          <Col sm={12}>
            <Alert variant='success'>
              Your email has been verified.
            </Alert>
          </Col>
        </Row>

      </div>;


    switch (this.state.workflowState) {
      case WorkflowState.INIT:
      case WorkflowState.VERIFY_CODE_STARTED:
        return <div> Loading... </div>;
      case WorkflowState.VERIFY_CODE_FAIL:
        return VerifyCodeFailedUI;
      case WorkflowState.VERIFY_CODE_SUCCESS:
      // case WorkflowState.RESET_PASSWORD_STARTED:
      // case WorkflowState.RESET_PASSWORD_FAIL:
        // return ResetPasswordUI;
      // case WorkflowState.RESET_PASSWORD_SUCCSS:
        return PasswordChangeSuccessdUI;
      default:
        return <></>
    }
  }

  // handleResetPasswordSubmit() {

  //   if (this.state.password === this.state.confirmpassword) {
  //     this.setState({ workflowState: WorkflowState.RESET_PASSWORD_STARTED })

  //     FirebaseClient.getInstance().getFirebaseAuth().confirmPasswordReset(
  //       this.state.resetCode, this.state.password
  //     )
  //       .then(resp => {
  //         this.setState({ success: true, workflowState: WorkflowState.RESET_PASSWORD_SUCCSS })
  //         // this.props.logInConnect(this.state.email, this.state.password)
  //         sendPasswordResetSuccess(this.state.email).catch();
  //       })
  //       .catch(err => {
  //         this.setState({ submitError: err, workflowState: WorkflowState.RESET_PASSWORD_FAIL })
  //       })
  //   } else {
  //     this.setState({ submitError: { message: 'Sorry the passwords don’t match, please try again.' }, workflowState: WorkflowState.RESET_PASSWORD_FAIL })
  //   }
  // }
}

const mapDispatchToProps = {
  logInConnect: logIn
};


export default connect(
  null,
  mapDispatchToProps,
)(VerifyEmail);
